import { useCallback } from "react";
import type { Athlete, Exercise } from "types";
import ExerciseHelpers from "helpers/ExerciseHelpers";

interface GenerateTemplateParams {
  athletes: Athlete[];
  exercises: Exercise[];
  imperialSystemEnabled: boolean;
}

function useOneRepMaxCsvTemplateGenerator() {
  const generateTemplate = useCallback(({ athletes, exercises }: GenerateTemplateParams) => {
    // Build FIRST header row (categories) and SECOND header row (exercise names)
    const categoryRow = ["", ""]; // Empty cells for AthleteId and Athlete Name columns
    const exerciseNameRow = ["AthleteId", "Athlete Name"];

    exercises.forEach((exercise) => {
      const hasVariants = ExerciseHelpers.hasVariants(exercise);

      if (hasVariants) {
        // Add category for both Left and Right variants
        categoryRow.push(exercise.category, exercise.category);
        exerciseNameRow.push(`${exercise.name} (Left)`, `${exercise.name} (Right)`);
      } else {
        // Add category once for bilateral exercise
        categoryRow.push(exercise.category);
        exerciseNameRow.push(exercise.name);
      }
    });

    // Build data rows
    const rows = athletes.map((athlete) => {
      const row = [athlete.id, `${athlete.firstName} ${athlete.lastName}`];

      // Add empty values for each exercise column
      exercises.forEach((exercise) => {
        const hasVariants = ExerciseHelpers.hasVariants(exercise);
        if (hasVariants) {
          row.push("", ""); // Left and Right
        } else {
          row.push(""); // Single value
        }
      });

      return row;
    });

    // Convert to CSV format with TWO header rows
    const csvRows = [categoryRow, exerciseNameRow, ...rows];
    const csvContent = csvRows.map((row) => row.map((cell) => `"${cell}"`).join(",")).join("\n");

    return csvContent;
  }, []);

  return { generateTemplate };
}

export default useOneRepMaxCsvTemplateGenerator;
